export enum NavigationState {
    Splash = 0,
    Live = 1,
    Music = 2,
    Contact = 3
}

export default NavigationState;